var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministrador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 3.79086 6.79086 2 9 2C11.2091 2 13 3.79086 13 6C13 8.20914 11.2091 10 9 10C6.79086 10 5 8.20914 5 6ZM9 3C7.34315 3 6 4.34315 6 6C6 7.65685 7.34315 9 9 9C10.6569 9 12 7.65685 12 6C12 4.34315 10.6569 3 9 3ZM2 13C2 11.8869 2.90315 11 4.00873 11L12.6707 11C12.5602 11.3128 12.5 11.6494 12.5 12H4.00873C3.44786 12 3 12.4467 3 13C3 14.3088 3.62226 15.2837 4.67262 15.9534C5.74318 16.636 7.26489 17 9 17C9.70752 17 10.3796 16.9395 11 16.8215V17.8376C10.3618 17.9466 9.68963 18 9 18C7.14526 18 5.41697 17.614 4.13499 16.7966C2.83281 15.9663 2 14.6912 2 13ZM13.5 13V12C13.5 10.8954 14.3954 10 15.5 10C16.6046 10 17.5 10.8954 17.5 12V13H18C18.5523 13 19 13.4477 19 14V18C19 18.5523 18.5523 19 18 19H13C12.4477 19 12 18.5523 12 18V14C12 13.4477 12.4477 13 13 13H13.5ZM14.5 12V13H16.5V12C16.5 11.4477 16.0523 11 15.5 11C14.9477 11 14.5 11.4477 14.5 12ZM16.25 16C16.25 15.5858 15.9142 15.25 15.5 15.25C15.0858 15.25 14.75 15.5858 14.75 16C14.75 16.4142 15.0858 16.75 15.5 16.75C15.9142 16.75 16.25 16.4142 16.25 16Z",
    fill: "rgb(0, 103, 155)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrador);
export default __webpack_public_path__ + "static/media/administrador.949654daeecadd23933a16a908021a36.svg";
export { ForwardRef as ReactComponent };